import { render, staticRenderFns } from "./AssignSuplierModal.vue?vue&type=template&id=70bc1d26&scoped=true&"
import script from "./AssignSuplierModal.vue?vue&type=script&lang=js&"
export * from "./AssignSuplierModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AssignSuplierModal.vue?vue&type=style&index=1&id=70bc1d26&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc1d26",
  null
  
)

export default component.exports